module.exports = __webpack_public_path__ + "media/images/pages/ic-twitter-2240e8d0a92f13084c6d0707782ad841.png";